import { render, staticRenderFns } from "./CashCallFormBdxList.vue?vue&type=template&id=c82dc6c0&scoped=true"
import script from "./CashCallFormBdxList.vue?vue&type=script&lang=js"
export * from "./CashCallFormBdxList.vue?vue&type=script&lang=js"
import style0 from "./CashCallFormBdxList.vue?vue&type=style&index=0&id=c82dc6c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82dc6c0",
  null
  
)

export default component.exports